export const INCIDENT_MODULE_NAME = 'incident';
